module.exports = __webpack_public_path__ + "80eb6d9e241daf216d9f8841c066bc1f.png";